import Model from './model.js';

export default class PreviousEmployment extends Model
{
    constructor(id, personId, perviousPlace, retirementStatus, dateAppointment, note){ 
        super()
        this.id                 = id ?? 0;
        this.personId           = personId;
        this.perviousPlace      = perviousPlace;
        this.retirementStatus   = retirementStatus;
        this.dateAppointment    = dateAppointment;
        this.note              = note;

        this.init()
    }

    update(data){
        Object.assign(this, data)
    }

    mapToUpdate(){
        return {
            perviousPlace:      this.perviousPlace ?? null,
            retirementStatus:   this.retirementStatus?.value ?? null,
            dateAppointment:    this.dateAppointment ?? null,
            notes:              this.note ?? null,
        }
    }

    mapToCreate(){
        let data = this.mapToUpdate();
        data.personId = this.personId ?? null;
        return data;
    }
}

